export class DashboardKompetenceKlarmeldtModel {
    brugerId: string;
    laegekompetenceId: string;

    static Build(responseModel: DashboardKompetenceKlarmeldtResponseModel): DashboardKompetenceKlarmeldtModel {
        let model = new DashboardKompetenceKlarmeldtModel();
        model.brugerId = responseModel.brugerId;
        model.laegekompetenceId = responseModel.laegekompetenceId;
        return model;
    }
}

export type DashboardKompetenceKlarmeldtResponseModel = {
    brugerId: string;
    laegekompetenceId: string;
}
